exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-kanban[data-v-7d2b8c86]{display:flex;margin:-8px -20px;padding:10px 20px;height:calc(100% + 16px)}", ""]);

// exports
